module.exports = __webpack_public_path__ + "static/media/transportVector.6cdd61dd.jpg";